(function() {
  const form = document.querySelector('[data-live-search-form]');
  if (!form) return;

  const input = form.querySelector('[data-live-search-input]');
  const wrapper = document.querySelector('[data-live-search]');

  // Crear el contenedor de resultados
  const dropdown = document.createElement('div');
  dropdown.setAttribute('data-live-search-results', '');
  dropdown.style.cssText = `
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-top: none;
    z-index: 9999;
    max-height: 400px;
    overflow-y: auto;
    display: none;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  `;
  wrapper.style.position = 'relative';
  wrapper.appendChild(dropdown);

  let debounceTimer;

  input.addEventListener('input', function() {
    clearTimeout(debounceTimer);
    const query = this.value.trim();

    if (query.length < 2) {
      dropdown.style.display = 'none';
      dropdown.innerHTML = '';
      return;
    }

    debounceTimer = setTimeout(() => fetchResults(query), 300);
  });

  async function fetchResults(query) {
    try {
      const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.sku`);
      const data = await res.json();
      const products = data.resources.results.products;
      renderResults(products, query);
    } catch(e) {
      console.error('Live search error:', e);
    }
  }

  function renderResults(products, query) {
    if (!products || products.length === 0) {
      dropdown.innerHTML = '<div style="padding:12px 16px;color:#666;font-size:14px;">No se encontraron productos</div>';
      dropdown.style.display = 'block';
      return;
    }

    dropdown.innerHTML = products.map(p => `
      <a href="${p.url}" style="display:flex;align-items:center;padding:10px 16px;text-decoration:none;color:inherit;border-bottom:1px solid #f0f0f0;gap:12px;">
        <img src="${p.featured_image?.url || ''}" alt="${p.title}" style="width:48px;height:48px;object-fit:cover;border-radius:4px;flex-shrink:0;" onerror="this.style.display='none'">
        <div>
          <div style="font-size:14px;font-weight:500;color:#222;">${p.title}</div>
          <div style="font-size:12px;color:#888;margin-top:2px;">${p.price ? formatPrice(p.price) : ''}</div>
        </div>
      </a>
    `).join('');

    dropdown.style.display = 'block';
  }

  function formatPrice(price) {
    return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(price);
  }

  // Cerrar al hacer click afuera
  document.addEventListener('click', function(e) {
    if (!wrapper.contains(e.target)) {
      dropdown.style.display = 'none';
    }
  });

  // Cerrar al enviar el form
  form.addEventListener('submit', function() {
    dropdown.style.display = 'none';
  });
})();